import {
    Chart,
    ChartArea,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartSeries,
    ChartSeriesDefaults,
    ChartSeriesItem,
    ChartTooltip,
    ChartValueAxis,
    ChartValueAxisItem,
} from '@progress/kendo-react-charts';

import { IEffectItem } from '../../../interfaces/IAssessment';

const blueColor = 'rgb(22, 81, 138)';
const yellowColor = 'rgb(247, 183, 48)';
interface IPredictedOutcomeChartProps {
    data: IEffectItem[];
}

function PredictedOutcomeChart(props: IPredictedOutcomeChartProps) {
    return (
        <Chart transitions={false}>
            <ChartArea background="transparent" />
            <ChartTooltip visible />
            <ChartSeriesDefaults type="bar" />
            <ChartCategoryAxis>
                <ChartCategoryAxisItem
                    categories={props.data.map((effect) => effect.displayName)}
                    majorGridLines={{ visible: false }}
                    labels={{
                        rotation: 'auto',
                        color: '#000',
                        position: 'start',
                    }}
                />
            </ChartCategoryAxis>

            <ChartValueAxis>
                <ChartValueAxisItem
                    majorGridLines={{ visible: true }}
                    minorGridLines={{ visible: false }}
                />
            </ChartValueAxis>

            <ChartSeries>
                <ChartSeriesItem
                    data={props.data.map((effect) => ({
                        value: effect.value,
                        color: effect.value < 0 ? blueColor : yellowColor,
                    }))}
                    labels={{ visible: false }}
                    tooltip={{ visible: false }}
                    border={{ width: 0 }}
                />
            </ChartSeries>
        </Chart>
    );
}

export default PredictedOutcomeChart;
